import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__container footer__container--wrap" }
const _hoisted_3 = { class: "footer__col top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "footer__col left" }
const _hoisted_6 = { class: "footer__rights a-font__xs" }
const _hoisted_7 = {
  class: "footer__privacy a-font__xs",
  href: "/my/files/policy.pdf",
  target: "_blank"
}

import AppPersonalAgreementDialog from '@/shared/components/AppPersonalAgreementDialog/AppPersonalAgreementDialog.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: require('@/projects/people/assets/img/footer/logo.png'),
              class: "footer__logo",
              alt: "логотип"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, " ©" + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_ctx.$t('general.copyright')), 1),
        _createVNode(AppPersonalAgreementDialog, null, {
          default: _withCtx(() => [
            _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('footer.policy')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})